import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import AppRoutes from './routes';
import Menu from "./components/Menu";
import Topbar from './components/Topbar';
import { UserProvider } from './contexts/UserContext';
import { PasswordResetProvider } from './contexts/PasswordResetContex';


function App() {
  return (
    <UserProvider>
      <PasswordResetProvider>
      <Router>
        <ConditionalMenu />
        <ConditionalTopbar />
        <AppRoutes />
      </Router>
      </PasswordResetProvider>
    </UserProvider>
  );
};

const ConditionalMenu = () => {
  const location = useLocation();
  const authPaths = ['/', '/auth/change-password', '/auth/otp-verification', '/auth/reset-password'];

  const showMenu = !authPaths.includes(location.pathname);

  return showMenu ? <Menu /> : null;
};

const ConditionalTopbar = () => {
  const location = useLocation();
  const authPaths = ['/', '/auth/change-password', '/auth/otp-verification', '/auth/reset-password'];

  const showTopbar = !authPaths.includes(location.pathname);

  return showTopbar ? <Topbar /> : null;
};

export default App;